import reactWrapper from "@harbor/elements/utils/react/wrapper";

import QoEComponent from "../QoEComponent";
import css from "../commonMagneticStyle.less";
const [HbrIcon, HbrTooltip] = reactWrapper(["hbr-icon", "hbr-tooltip"]);

const QoeListComponent = ({
  overviewPage,
  reporting,
  iconType,
  qoeScore,
  qoeLabels,
  tooltipText,
  position,
  ellipsis
}) => {
  const component = [];
  for (let qoeIndex = 0; qoeIndex < iconType.length; qoeIndex++) {
    component.push(
      <div
        className={
          overviewPage
            ? css["common-qoe-list-overview"]
            : css["common-qoe-list"]
        }
        key={qoeIndex}
      >
        <QoEComponent
          iconType={iconType[qoeIndex]}
          qoeScore={reporting ? qoeScore[qoeIndex] : qoeScore[qoeIndex].count}
          qoeTextValue={qoeLabels[qoeIndex]}
          reporting={reporting}
          ellipsis={ellipsis}
        />
        {!reporting && tooltipText && qoeIndex === position && (
          <div className={css["tooltip-wrapper-default"]}>
            <HbrTooltip content={tooltipText} placement="top">
              <HbrIcon name="info" sentiment="neutral" />
            </HbrTooltip>
          </div>
        )}
      </div>
    );
  }
  return component.map(c => c);
};

export default QoeListComponent;
